export type JSONSerializable = object | string | number | boolean | null | undefined;

type Listener = () => void;

const listenersByKey = new Map<string, Set<Listener>>();

export function subscribe(key: string, listener: Listener): () => void {
    let listeners = listenersByKey.get(key);
    if (!listeners) {
        listeners = new Set();
        listenersByKey.set(key, listeners);
    }

    listeners.add(listener);
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            listenersByKey.delete(key);
        }
    };
}

export function notify(key: string): void {
    listenersByKey.get(key)?.forEach(listener => listener());
}
